import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { RoleUpdate } from "../../redux/services/RoleService/role.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { closeModal, refreshList } from "../../redux/features/modalSlice";
import { ActiveDepartmentList } from "../../redux/services/DepartmentService/deparment.Services";

function EditRole({ data, onSuccess }) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    department_id: "",
    status: true,
  });

  // Fetch departments for dropdown
  useEffect(() => {
    fetchDepartmentList();
  }, []);

  // Prefill form when `data` changes
  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        // ✅ API se jo bhi field aaye — sab handle karo
        department_id:
          data.vendor_department_id ||
          data.department_id ||
          data.department?.id ||
          "",
        status:
          data.status === 1 ||
          data.status === "1" ||
          data.status === true,
      });
    }
  }, [data]);

  const fetchDepartmentList = async () => {
    try {
      const res = await ActiveDepartmentList();
      if (res?.success) {
        setDepartmentList(res.data || []);
      }
    } catch (error) {
      console.log(error);
      errorToast("Something went wrong");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "status" ? value === "Active" : value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = ["Role Name is required"];
    }

    if (!formData.department_id) {
      newErrors.department_id = ["Please select Department"];
    }

    setErrors(newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }

    try {
      setIsLoading(true);

      // ✅ Department bhi bhej rahe hain — agar API support karega toh update hoga
      const payload = {
        id: data?.id,
        name: formData.name,
        department_id: Number(formData.department_id),
      };

      const res = await RoleUpdate(payload);
      successToast(res?.message || "Role Updated Successfully");

      if (onSuccess) {
        await onSuccess();
      }

      dispatch(refreshList());
      dispatch(closeModal());
    } catch (err) {
      console.log(err);
      errorToast(err?.message || "Error updating role");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-form-wrapper">
      <form onSubmit={handleSubmit} className="row">
        {/* DEPARTMENT — editable */}
        <div className="col-md-12 mb-3">
          <label className="form-label">
            Select Department <span className="text-danger">*</span>
          </label>
          <select
            name="department_id"
            value={formData.department_id}
            onChange={handleChange}
            className={`form-control ${
              errors?.department_id ? "is-invalid" : ""
            }`}
          >
            <option value="">Select Department</option>
            {departmentList?.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
          {errors?.department_id && (
            <div className="invalid-feedback d-block">
              {Array.isArray(errors.department_id)
                ? errors.department_id[0]
                : errors.department_id}
            </div>
          )}
        </div>

        {/* ROLE NAME */}
        <div className="col-md-12 mb-3">
          <label>
            Role Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={`form-control ${errors?.name ? "is-invalid" : ""}`}
            placeholder="Enter role name"
          />
          {errors?.name && (
            <div className="invalid-feedback d-block">{errors.name[0]}</div>
          )}
        </div>

        {/* STATUS — status-update endpoint se handle karo, edit form me mat rakho
            agar API support nahi karta update endpoint me */}
        {/* <div className="col-md-12 mb-3">
          <label>Status</label>
          <select
            name="status"
            value={formData.status ? "Active" : "Inactive"}
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div> */}

        <div className="col-md-12 text-end">
          <button type="submit" disabled={isLoading} className="add-btn">
            {isLoading ? "Updating..." : "Update Role"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditRole;